import React, { useState, useEffect } from "react";
import Axios from "axios";
import { API_BASE_URL, GET_PO_BY_ID } from "../../../Config";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";
// import ImageWithBasePath from "../../img/imagewithbasebath";
// import jsPDF from "jspdf";
import "jspdf-autotable";
// import imageFile from "../../../../public/assets/img/41115.png"
import html2pdf from "html2pdf.js";
import { useRef } from "react";

const ViewPurchase = ({ POObj }) => {
  const [userDataSession, setUserDataSession] = useState([]);
  const [formattedDate, setFormattedDate] = useState("");
  const [formattedExpectedDate, setFormattedExpectedDate] = useState("");
  const [loading, setLoading] = useState("");
  const [firstData, setFirstData] = useState(null);
  const [totalAmount, setTotalAmount] = useState("");
  const [taxAmount, setTaxAmount] = useState("");
  const [viewProducts, setViewProducts] = useState([]);

  // #region Session userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (POObj) {
      // Parse and format PODate
      // console.log(POObj, "ppoobbjj");
      if (POObj.PODate) {
        const poDate = new Date(POObj.PODate);
        const formattedPODate = poDate.toISOString().split("T")[0];
        setFormattedDate(formattedPODate);
      }

      // Parse and format ExpectedDate
      // console.log("ExpectedDate:", POObj.ExpectedDate); // Debugging step
      if (POObj.ExpectedDate) {
        const expectedDate = new Date(POObj.ExpectedDate);
        const formattedExpectedDate = expectedDate.toISOString().split("T")[0];
        setFormattedExpectedDate(formattedExpectedDate);
      } else {
        console.log("ExpectedDate is not available in POObj");
      }
    }
  }, [POObj]);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && POObj && POObj.PurchaseId) {
      setLoading(true);
      const url = `${API_BASE_URL}${GET_PO_BY_ID}?PurchaseId=${POObj.PurchaseId}`;
      Axios.get(url)
        .then((response) => {
          if (response.data.Status) {
            setViewProducts(response.data.ResultData);
            setFirstData(response.data.ResultData[0]);
            // console.log(response.data.ResultData, "req details");
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [userDataSession, POObj]);

  useEffect(() => {
    let totalTaxAmt = 0;
    let totalAmount = 0;

    if (viewProducts && viewProducts.length > 0) {
      totalTaxAmt = viewProducts.reduce((acc, product) => {
        const taxRate = product.CGSTRate + product.SGSTRate;
        const taxAmount =
          (product.UnitPrice * product.Quantity * taxRate) / 100;
        return acc + (taxAmount || 0);
      }, 0);

      totalAmount = viewProducts.reduce((acc, product) => {
        const amount = product.UnitPrice * product.Quantity;
        return acc + (amount || 0);
      }, 0);
    }

    setTaxAmount(totalTaxAmt);
    setTotalAmount(totalAmount + totalTaxAmt - POObj?.DiscountAmount);
  }, [viewProducts]);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );

  //region pdf download
  const printRef = useRef();
  const [showPDF, setShowPDF] = useState(false);

  const generatePDF = () => {
    setShowPDF(true); // Show the div before generating the PDF

    const element = printRef.current;

    html2pdf()
      .from(element)
      .save("purchase_order.pdf")
      .then(() => {
        setShowPDF(false); // Hide the div after the PDF is generated
      });
  };

  return (
    <div>
      {/* <h4 className='ms-2'>(PO-{firstData ? firstData.AutoGenTransactionNo : ''})</h4> */}
      {/* Add Purchase */}

      <div
        className="offcanvas offcanvas-end"
        tabIndex={-1}
        id="offcanvasRightPOView"
        aria-labelledby="offcanvasRightLabel"
        style={{ minWidth: "300px", maxWidth: "55%" }}
      >
        <div className="offcanvas-header">
          <h4 id="offcanvasRightLabel" className="me-3">
            View Purchase Order (PO-
            {firstData ? firstData.AutoGenTransactionNo : ""})
          </h4>

          {showPDF ? (
            <tr>
              <td colSpan="12" className="text-center">
                Downloading...
              </td>
            </tr>
          ) : (
            <ul className="table-top-head">
              <li onClick={generatePDF}>
                <OverlayTrigger placement="bottom" overlay={renderTooltip}>
                  <Link>
                    {/* <ImageWithBasePath
                    src="assets/img/pdfDownload.svg"
                    alt="img"
                  /> */}
                    <i className="fa-solid fa-file-arrow-down fa-xl"></i>
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          )}

          <button
            type="button"
            className="btn-close text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          />
        </div>
        <hr />
        <div className="offcanvas-body">
          <form>
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks ">
                  <label>Store</label>
                  <input
                    type="text"
                    className="form-control"
                    value={firstData ? firstData?.StoreName : ""}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks add-product">
                  <label>Supplier</label>
                  <div className="row">
                    <div className="col-lg-10 col-sm-10 col-10">
                      <input
                        type="text"
                        className="form-control"
                        value={
                          firstData && firstData.SupplierName
                            ? firstData.SupplierName.toLowerCase()
                                .split(" ")
                                .map(
                                  (word) =>
                                    word.charAt(0).toUpperCase() + word.slice(1)
                                )
                                .join(" ")
                            : ""
                        }
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Date</label>
                  <div className="input-groupicon calender-input">
                    <input
                      type="date"
                      className="form-control"
                      value={formattedDate}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks">
                  <label>Expected Date</label>
                  <div className="input-groupicon calender-input">
                    <input
                      type="date"
                      className="form-control"
                      value={formattedExpectedDate}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-12">
                <div className="input-blocks me-3">
                  <label className="form-label">Status</label>
                  <input
                    className="form-control"
                    type="text"
                    value={POObj ? POObj.POStatus : ""}
                    readOnly
                  />
                </div>
              </div>
              <div className=" col-lg-3 col-md-3form-group">
                <label className="form-label">Discount Amount</label>
                <input
                  type="float"
                  className="form-control"
                  // placeholder='Enter discount'
                  value={firstData ? firstData.DiscountAmount : ""}
                  readOnly
                />
              </div>
            </div>
            <div className="row">
              {/* <div className='col-lg-3 col-md-3 form-group'>
                                <label className='form-label'>Type</label>
                                <input
                                    type='float'
                                    className='form-control'
                                    // placeholder='Enter discount'
                                    value={firstData ? firstData.DiscountType : ''}
                                    readOnly
                                />
                            </div> */}
            </div>
            <div className="row mb-2">
              <div className="col-lg-12">
                <div className="modal-body-table">
                  <div
                    className="table-responsive"
                    style={{ maxHeight: "20rem", overflowY: "auto" }}
                  >
                    <table className="table  dataew">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Product</th>
                          <th>Quantity</th>
                          <th>Price</th>
                          <th>Units</th>
                          <th>Tax</th>
                          <th>Amount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="12" className="text-center">
                              Loading...
                            </td>
                          </tr>
                        ) : viewProducts.length !== 0 ? (
                          viewProducts.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.ProductName}</td>
                              <td>{item.Quantity}</td>
                              <td>{item.UnitPrice}</td>
                              <td>{item.Units}</td>
                              <td>
                                {item.CGSTRate}, {item.SGSTRate}
                              </td>
                              <td>
                                {(
                                  (item.Quantity || 0) * (item.UnitPrice || 0) +
                                  (((item.CGSTRate || 0) +
                                    (item.SGSTRate || 0)) /
                                    100) *
                                    (item.Quantity || 0) *
                                    (item.UnitPrice || 0)
                                ).toFixed(2)}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No Data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                    <div className="justify-content-between d-flex mt-2">
                      <p className="badge badge-primary fs-6 col-4">
                        Total Discount:{" "}
                        <span className="fw-bold fs-5">
                          {Number(POObj?.DiscountAmount || 0).toFixed(2)}
                        </span>
                      </p>
                      <p className="badge badge-primary fs-6 col-3">
                        Total Tax:{" "}
                        <span className="fw-bold fs-5">
                          {Number(taxAmount || 0).toFixed(2)}
                        </span>
                      </p>
                      <p
                        style={{ height: "1.8rem" }}
                        className="badge badge-primary fs-6 col-4"
                      >
                        Total Amount:{" "}
                        <span className="fw-bold fs-5">
                          {Number(totalAmount || 0).toFixed(2)}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <div className="input-blocks">
                    <label>Shipment Details</label>
                    <textarea readOnly value={POObj?.Notes}></textarea>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div
        ref={printRef}
        className="container"
        style={{
          width: "800px",
          margin: "0 auto",
          display: showPDF ? "block" : "none",
          fontFamily: "Nunito, sans-serif",
        }}
      >
        <div
          className="center-image"
          style={{ textAlign: "center", margin: "10px" }}
        >
          <img
            src={`assets/img/${userDataSession.OrgId}.png`}
            alt="Purchase Order Image"
            width="190px"
            height="80px"
          />
        </div>
        <hr />

        <div
          className="d-flex"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "10px",
            // paddingLeft: "15px",
          }}
        >
          <h2 style={{ textAlign: "left", color: "#FF9F43" }}>
            PURCHASE ORDER
          </h2>
          <div>
            <p style={{ margin: 0 }}>Date: {new Date().toLocaleDateString()}</p>
            <h2 style={{ textAlign: "left", color: "#FF9F43", margin: 0 }}>
              PO - {firstData?.AutoGenTransactionNo || ""}
            </h2>
          </div>
        </div>

        <div
          className="vendor-ship"
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <div style={{ width: "48%" }}>
            <p
              className="ship"
              style={{
                backgroundColor: "#FF9F43",
                color: "white",
                padding: "5px",
                fontWeight: "bold",
              }}
            >
              <strong>SUPPLIER DETAILS</strong>
            </p>
            <p style={{ margin: "4px 0" }}>
              Supplier Name: {firstData?.SupplierName || ""}
            </p>
            <p style={{ margin: "4px 0" }}>
              GSTIN: {firstData?.SupplierGSTIN || ""}
            </p>
            <p style={{ margin: "4px 0" }}>PO Date: {formattedDate} </p>
            <p style={{ margin: "4px 0" }}>
              Expected Date: {formattedExpectedDate}
            </p>
            <p style={{ margin: "4px 0" }}>Status: {POObj?.POStatus || ""}</p>
            <p style={{ margin: "4px 0" }}>
              Discount: {firstData?.DiscountAmount || ""}
            </p>
          </div>
          <div style={{ width: "48%" }}>
            <p
              className="ship"
              style={{
                backgroundColor: "#FF9F43",
                color: "white",
                padding: "5px",
                fontWeight: "bold",
              }}
            >
              <strong>SHIP TO</strong>
            </p>
            <p style={{ margin: "4px 0" }}>
              Store Name: {firstData?.StoreName || ""}
            </p>
            <p style={{ margin: "4px 0" }}>GSTIN: {firstData?.StoreGSTIN} </p>
            <p style={{ margin: "4px 0" }}>
              Phone No: {firstData?.StorePhoneNo}
            </p>
            <p style={{ margin: "4px 0" }}>
              City - State: {firstData?.StoreCity || ""}{" "}
              {firstData?.StoreState || ""}
            </p>
            <p style={{ margin: "4px 0" }}>
              Address: {firstData?.StoreAddress || ""}
            </p>
          </div>
        </div>

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginBottom: "15px",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "4px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                #
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "4px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                PRODUCT
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "4px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                QUANTITY
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "4px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                PRICE
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "4px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                UNITS
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "4px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                TAX
              </th>
              <th
                style={{
                  border: "1px solid #000",
                  padding: "4px",
                  textAlign: "left",
                  backgroundColor: "#FF9F43",
                  color: "white",
                }}
              >
                AMOUNT
              </th>
            </tr>
          </thead>
          <tbody>
            {viewProducts.map((item, index) => (
              <tr key={item.index}>
                <td style={{ border: "0.5px solid #000", padding: "5px" }}>
                  {index + 1}
                </td>
                <td style={{ border: "0.5px solid #000", padding: "5px" }}>
                  {item.ProductName}
                </td>
                <td style={{ border: "0.5px solid #000", padding: "5px" }}>
                  {item.Quantity}
                </td>
                <td style={{ border: "0.5px solid #000", padding: "5px" }}>
                  {item.UnitPrice}
                </td>
                <td style={{ border: "1px solid #000", padding: "5px" }}>
                  {item.Units}
                </td>
                <td style={{ border: "1px solid #000", padding: "5px" }}>
                  {`${item.CGSTRate + item.SGSTRate}%`}
                </td>
                <td style={{ border: "1px solid #000", padding: "5px" }}>
                  {(
                    (item.Quantity || 0) * (item.UnitPrice || 0) +
                    (((item.CGSTRate || 0) + (item.SGSTRate || 0)) / 100) *
                      (item.Quantity || 0) *
                      (item.UnitPrice || 0)
                  ).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p>
          <strong>Shipment Details:</strong>
        </p>
        <p style={{ marginTop: "-10px" }}>{POObj?.Notes || ""}</p>
        <div
          className="d-flex row"
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginRight: "-15px",
            marginLeft: "-15px",
            paddingLeft: "15px",
          }}
        >
          <div
            className="comments col-6"
            style={{
              flex: "0 0 50%",
              maxWidth: "50%",
              backgroundColor: "#f0f0f0",
              padding: "10px",
            }}
          >
            <p>
              <strong>Comments or Special Instructions:</strong>
            </p>

            <p>Thank you for your business.</p>
          </div>
          <div
            className="totals col-4"
            style={{
              flex: "0 0 41.66%",
              maxWidth: "41.66%",
              borderStyle: "solid",
              borderWidth: "1px",
              padding: "10px",
            }}
          >
            <table style={{ width: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ border: "none", textAlign: "left" }}>
                    Total Discount
                  </td>
                  <td style={{ border: "none", textAlign: "left" }}>
                    {Number(POObj?.DiscountAmount || 0).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td style={{ border: "none", textAlign: "left" }}>
                    Total Tax
                  </td>
                  <td style={{ border: "none", textAlign: "left" }}>
                    {Number(taxAmount || 0).toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Total Amount</strong>
                  </td>
                  <td
                    className="total"
                    style={{
                      border: "none",
                      padding: "5px",
                      textAlign: "left",
                      backgroundColor: "#FF9F43",
                      color: "white",
                    }}
                  >
                    {Number(totalAmount || 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p>
          <strong>Payment Terms:</strong>
        </p>
        <ul style={{ marginTop: "-10px" }}>
          <li>
            <strong>Payment Due Date:</strong> Payment should be made within{" "}
            <strong>30 days</strong> from the date of invoice.
          </li>
          <li>
            <strong>Accepted Payment Methods:</strong> Bank Transfer, Credit
            Card, or UPI (Cash payments not accepted).
          </li>
          <li>
            <strong>Late Payment Charges:</strong> A late fee of{" "}
            <strong>1.5% per month</strong> may be applied to overdue balances.
          </li>
          <li>
            <strong>Advance Payment:</strong>{" "}
            <strong>50% advance payment</strong> is required for orders
            exceeding a specified amount.
          </li>
          <li>
            <strong>Tax & Deductions:</strong> All applicable taxes will be
            borne by the purchaser as per government regulations.
          </li>
          <li>
            <strong>Refunds & Disputes:</strong> Disputes must be raised within{" "}
            <strong>7 days</strong> of receipt of the invoice.
          </li>
        </ul>

        <div
          className="footer"
          style={{
            fontSize: "12px",
            textAlign: "center",
            color: "gray",
            marginTop: "20px",
          }}
        >
          <p>
            If you have any questions about this purchase order, please contact
          </p>
        </div>
      </div>
    </div>
  );
};

ViewPurchase.propTypes = {
  POObj: PropTypes.object.isRequired,
};

export default ViewPurchase;
